import { h } from 'vue';

import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

const MAIN_PREFIX = '/goals/';

// a render function rather than a `template` string: `vue` resolves to the runtime-only
// build now that @vue/compat is gone, and a template compiled at runtime is the one thing
// that build cannot do - it would render nothing and warn once, on a route nobody visits
// until something has already gone wrong
const errorPage = message => ({
    render: () => h('div', { class: 'alert alert-danger' }, message),
});

const goalDetailPageChildren = [
    {
        path: '',
        component: () => import(/* webpackChunkName: "goals" */ './GoalDetailPage/GoalDetailPageMainTasks/GoalDetailPageMainTasks.vue'),
        props: true,
        name: 'GoalDetailPageMainTasks',
    },
    {
        path: 'timeline/',
        component: () => import(/* webpackChunkName: "goals" */ './GoalDetailPage/GoalDetailPageMainTimeline/GoalDetailPageMainTimeline.vue'),
        props: true,
        name: 'GoalDetailPageMainTimeline',
    },
    {
        path: 'members/',
        component: () => import(/* webpackChunkName: "goals" */ './GoalDetailPage/GoalDetailPageMainMembers.vue'),
        props: true,
        name: 'GoalDetailPageMainMembers',
    },
    {
        path: 'about/',
        component: () => import(/* webpackChunkName: "goals" */ './GoalDetailPage/GoalDetailPageMainAbout.vue'),
        props: true,
        name: 'GoalDetailPageMainAbout',
    },
    {
        path: 'attachments/',
        component: () => import(/* webpackChunkName: "goals" */ './GoalDetailPage/GoalDetailPageMainAttachments.vue'),
        props: true,
        name: 'GoalDetailPageMainAttachments',
    },
    {
        path: 'exports/',
        component: () => import(/* webpackChunkName: "goals" */ './GoalDetailPage/GoalDetailPageExports.vue'),
        props: true,
        name: 'GoalDetailPageExports',
    },
    {
        path: '404/',
        name: '404',
        component: errorPage('Not Found'),
        meta: {
            isErrorPage: true
        }
    },
    {
        path: '403/',
        name: '403',
        component: errorPage('Forbidden'),
        meta: {
            isErrorPage: true
        }
    }
];

export default defineSection({
    head: sectionHead({
        title () {
            return this.$customTerm('Goals');
        },
        icon: FAVICONS.goals,
    }),
    routes: [
        {
            path: MAIN_PREFIX,
            component: () => import(/* webpackChunkName: "goals" */ './MyGoalsList.vue'),
            props: true,
            name: 'myGoalsListPageMain',
        },
        {
            path: MAIN_PREFIX + 'tasks/',
            component: () => import(/* webpackChunkName: "goals" */ './MyTasksList.vue'),
            props: true,
            name: 'myTasksListPageMain',
        },
        {
            path: MAIN_PREFIX + 'list/',
            component: () => import(/* webpackChunkName: "goals" */ './UsersWhoseGoalsIManage/UsersWhoseGoalsIManagePage.vue'),
            props: true,
            name: 'UsersWhoseGoalsIManagePage',
        },
        {
            path: MAIN_PREFIX + ':goalId(\\d+)/',
            component: () => import(/* webpackChunkName: "goals" */ './GoalDetailPage/GoalDetailPageMain.vue'),
            children: goalDetailPageChildren,
            props: true,
        },
        {
            path: MAIN_PREFIX + ':goalId(\\d+)/task/:taskId(\\d+)/',
            component: () => import(/* webpackChunkName: "goals" */ './GoalTaskPage/GoalTaskPage.vue'),
            props: true,
        },
        {
            path: MAIN_PREFIX + ':goalId(\\d+)/task/:taskId(\\d+)/code/:accessCode/',
            component: () => import(/* webpackChunkName: "goals" */ './GoalTaskPage/GoalTaskPage.vue'),
            props: true,
        },
        {
            // scoped to the section: as one of many route tables this may no longer
            // swallow every url the other sections did not claim.
            // router 4 dropped the bare '*' wildcard for a named catch-all param
            path: MAIN_PREFIX + ':pathMatch(.*)*',
            name: '404nf',
            component: errorPage('Not Found'),
            meta: {
                isErrorPage: true
            }
        }
    ]
});
